import { render } from "./CategoryView.vue?vue&type=template&id=44a6d370&scoped=true"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=44a6d370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a6d370"]])

export default __exports__